import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

type DeleteUserGroupsParams = {
  user_group_ids: string[];
};

export function useDeleteUserGroups({
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, DeleteUserGroupsParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ user_group_ids }) => {
      await client.delete(`/apps/${applicationID}/user_groups`, {
        params: { 'user_group_ids[]': user_group_ids },
      });
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['user-groups']);
      },
    }
  );
}
